// extracted by mini-css-extract-plugin
export default {"base":"Header_base__Nm8oB","heading":"Header_heading__tTiA3","center":"Header_center__SwJ+J"};